export const skillsData = [
  'Python',
  'PyTorch',        
  'Hugging Face',
  'CUDA',
  'OpenAI',
  'FastAPI',
  'Docker',
  'GitHub',
  'AWS',
  'GCP',
  'Gradio',
  'Selenium',
  'MongoDB',
  "numpy",
  "Git",
  "Tensorflow",
  "MySQL",
  "PostgreSQL",
  "VectorDB",
];
